import { LOCALE_ID, NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from "@angular/router";
import { HttpModule } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BsModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { TreeModule } from "angular-tree-component";
import { NKDatetimeModule } from "ng2-datetime/ng2-datetime";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { ChartsModule } from 'ng2-charts';
import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
import { FileUploadModule } from 'ng2-file-upload';
import { CalendarModule } from 'angular-calendar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimplebarAngularModule } from 'simplebar-angular';

import { SharedModule } from './directives';
import { ScriptComponent } from "./components/scripthack/scripthack.component";
import localeDe from '@angular/common/locales/ru';
import { registerLocaleData } from '@angular/common';
import { BasicTreeComponent } from './components/basic-tree/basic-tree.component';
import { WorkPlaceComponent } from "./components/workplace/workplace.component";
import { CalendarEventsComponent } from "app/components/calendar_events/calendar.events.component";
import { PortfolioComponent } from "app/components/portfolio/portfolio.component";
import { ContractComponent } from "app/components/contract/contract.component";
import { PersonComponent } from "./components/person/person.component";
import { HelpComponent } from "./components/help/help.component";
import { RequestsComponent } from "app/components/requests/requests.component";
import { AgentsComponent } from "app/components/agents/agents.component";
import { AgentTreeComponent } from "./components/agents/agent-tree.component";
import { AgentComponent } from "app/components/agents/agent.component";
import { RolesComponent } from "./components/role/roles.component";
import { EventtypesComponent } from "./components/eventtypes/eventtypes.component";
import { Guard } from "./components/guard";
import { RoleComponent } from "./components/role/role.component";
import { AppComponent } from "./app.component";
import { ContactsComponent } from "./components/contacts/contacts.component";
import { BarChartComponent } from "app/components/charts/bar-chart.component";
import { EventComponent } from "./components/events/events.component";
import { RatingsComponent } from "app/components/ratings/ratings.component";
import { ChartPieComponent } from "./components/charts/pie-chart.component";
import { CountTimer } from "app/services/perfomance.service";
import { Base2Service } from "./services/base2.service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CalendarHeaderComponent } from "./util/calendar-header.component";
import { EventInfoComponent } from "./components/event_info/event_info.component";
import { ReportsComponent } from './components/reports/reports.component';
import { AgentReportsComponent } from './components/my-sales/left-block/agent_reports/agent_reports.component';
import { RatingFullComponent } from "./components/rating-full/rating-full.component";
import { AchievementsFullComponent } from './components/achievements-full/achievements-full.component';
import { ShopFullComponent } from './components/shop-full/shop-full.component';
import { TasksFullComponent } from './components/tasks-full/tasks-full.component';
import { ApplicationsNewComponent } from './components/applications-new/applications-new.component';
// import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { SSOUtility } from "./util/sso.utility";
import { AccessDeniedComponent } from "./components/access-denied/access-denied";
import { AgentUtility } from "./util";
import { MeetingsComponent } from './components/meetings/meetings.component';
import { MeetingCardComponent } from './components/meetings/meeting-card/meeting-card.component';
import { CreateComponent as MeetingCreateComponent }  from './components/meetings/create/create.component';
import { UpdateComponent as MeetingUpdateComponent } from './components/meetings/update/update.component';
import { AdminGuard } from "./components/admin-guard";
import { ClientMeetingsHistoryComponent } from './components/meetings/update/client-meetings-history/client-meetings-history.component';
import { OrgstructureNewComponent } from './components/shared/orgstructure-new/orgstructure-new.component';
import { MySalesComponent } from './components/my-sales/my-sales.component';
import { NewContractStatusComponent } from './components/my-sales/right-block/new-business/new-contract-status/new-contract-status.component';
import { LeftBlockComponent } from './components/my-sales/left-block/left-block.component';
import { RightBlockComponent } from './components/my-sales/right-block/right-block.component';
import { UserInfoComponent } from './components/my-sales/left-block/user-info/user-info.component';
import { AgentStatisticsComponent } from './components/my-sales/left-block/sales-statistics/agent/agent-statistics.component';
import { CurrentLevelComponent } from './components/my-sales/left-block/current-level/current-level.component';
import { PathFKComponent } from './components/my-sales/left-block/path-fk/path-fk.component';
import { SumOfRewardComponent } from './components/my-sales/left-block/sum-of-reward/sum-of-reward.component';
import { AdditionalInformationComponent } from './components/my-sales/left-block/additional-information/additional-information.component';
import { NewBusinessComponent } from './components/my-sales/right-block/new-business/new-business.component';
import { SizeSalesComponent } from './components/my-sales/right-block/size-sales/size-sales.component';
import { KspComponent } from './components/my-sales/right-block/size-sales/ksp/ksp.component';
import { DirectorStatisticsComponent } from './components/my-sales/left-block/sales-statistics/director/director-statisctics.component';
import { ManagerStatisticsComponent } from './components/my-sales/left-block/sales-statistics/manager/manager-statistics.component';
import { AchievePlanComponent } from './components/my-sales/right-block/achieve-plan/achieve-plan.component';
import { KspDirectorComponent } from './components/my-sales/right-block/achieve-plan/ksp-director/ksp-director.component';
import { DirectorsListComponent } from './components/my-sales/directors-list/directors-list.component';
import { AgentsListComponent } from './components/my-sales/agents-list/agents-list.component';
import { ManagersAndAgentsListComponent } from './components/my-sales/managers-and-agents-list/managers-and-agents-list.component';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeDe, 'ru');

const appRoutes: Routes = [
    { path: '', component: WorkPlaceComponent, canActivate: [Guard] },
    { path: AgentUtility.ACCESS_DENIED, component:AccessDeniedComponent},
    { path: 'events', component: CalendarEventsComponent, canActivate: [Guard] },
    // { path: 'events/:contractId', component: component.CalendarEventsComponent, canActivate: [Guard] },
    { path: 'portfolio', component: PortfolioComponent, canActivate: [Guard] },
    { path: 'portfolio/:number', component: ContractComponent, canActivate: [Guard] },
    { path: 'person/:id', component: PersonComponent, canActivate: [Guard] },
    // { path: 'agent/:id', component: component.HomeComponent, canActivate: [Guard] },
    { path: 'help', component: HelpComponent, canActivate: [Guard] },
    { path: 'requests', component: RequestsComponent, canActivate: [Guard] },
    { path: 'requests/anonymous', component: RequestsComponent },
    { path: 'agents', component: AgentsComponent, canActivate: [Guard] },
    { path: 'agent-tree', component: AgentTreeComponent, canActivate: [Guard] },
    { path: 'agent/:id', component: WorkPlaceComponent, canActivate: [Guard] },
    { path: 'agent', component: AgentComponent, canActivate: [Guard] },
    { path: 'rating-full', component: RatingFullComponent },
    { path: 'achievements-full', component: AchievementsFullComponent },
    { path: 'applications/new', component: ApplicationsNewComponent },
    { path: 'shop-full', component: ShopFullComponent },
    { path: 'tasks-full', component: TasksFullComponent },
    { path: 'roles', component: RolesComponent, canActivate: [Guard] },
    { path: 'eventtypes', component: EventtypesComponent, canActivate: [Guard] },
    { path: 'test', component: BasicTreeComponent, canActivate: [Guard] },
    { path: 'reports', component: ReportsComponent, canActivate: [Guard] },
    { path: 'mysales', component: MySalesComponent, canActivate: [Guard] },
    { path: 'mysales/agent-reports', component: AgentReportsComponent, canActivate: [Guard] },
    { path: 'meetings', component:MeetingsComponent, canActivate: [AdminGuard]},
    { path: 'meetings/create', component:MeetingCreateComponent, canActivate: [Guard]},
    { path: 'meetings/edit/:id', component:MeetingUpdateComponent, canActivate: [Guard],
    runGuardsAndResolvers: 'always'},
    { path: '**', component: WorkPlaceComponent, canActivate: [Guard] }

    // { path: 'contracts', component: ContractsComponent, canActivate: [Guard] },
];

@NgModule({
    imports: [
        BrowserModule,
        RouterModule.forRoot(appRoutes, {onSameUrlNavigation: 'reload'}),
        HttpModule,
        FormsModule,
        ReactiveFormsModule,
        BsModalModule,
        TreeModule,
        NKDatetimeModule,
        Ng2AutoCompleteModule,
        SharedModule,
        ChartsModule,
        ColorPickerModule,
        FileUploadModule,
        HttpClientModule,
        CalendarModule.forRoot(),
        ReactiveFormsModule,
        SimplebarAngularModule
        // ,KeycloakAngularModule
    ],
    declarations: [
        AppComponent,
        AgentsComponent,
        AgentTreeComponent,
        AgentComponent,
        RolesComponent,
        HelpComponent,
        RoleComponent,
        EventtypesComponent,
        ContactsComponent,
        WorkPlaceComponent,
        EventComponent,
        BarChartComponent,
        ChartPieComponent,
        RatingsComponent,
        PortfolioComponent,
        CalendarEventsComponent,
        ContractComponent,
        PersonComponent,
        RequestsComponent,
        ScriptComponent,
        BasicTreeComponent,
        CalendarHeaderComponent,
        EventInfoComponent,
        ReportsComponent,
        AgentReportsComponent,
        RatingFullComponent,
        AchievementsFullComponent,
        ShopFullComponent,
        TasksFullComponent,
        ApplicationsNewComponent,
        AccessDeniedComponent,
        MeetingsComponent,
        MeetingCardComponent,
        MeetingCreateComponent,
        MeetingUpdateComponent,
        ClientMeetingsHistoryComponent,
        OrgstructureNewComponent,
        MySalesComponent,
        NewContractStatusComponent,
        LeftBlockComponent,
        RightBlockComponent,
        UserInfoComponent,
        AgentStatisticsComponent,
        CurrentLevelComponent,
        PathFKComponent,
        SumOfRewardComponent,
        AdditionalInformationComponent,
        NewBusinessComponent,
        SizeSalesComponent,
        KspComponent,
        DirectorStatisticsComponent,
        ManagerStatisticsComponent,
        AchievePlanComponent,
        KspDirectorComponent,
        DirectorsListComponent,
        AgentsListComponent,
        ManagersAndAgentsListComponent
        // ContractsComponent
    ],
    providers: [Guard, AdminGuard, Base2Service, HttpClient, CountTimer, ColorPickerService, 
        {
            provide: LOCALE_ID,
            useValue: 'ru-RU' // 'de-DE' for Germany, 'fr-FR' for France ...
        },
        {
            provide: APP_INITIALIZER, 
            useValue: () => SSOUtility.InitKeycloak(), 
            multi: true
        }
],
    bootstrap: [AppComponent]
})
export class AppModule {
}